import React from 'react';

const FinishPage: React.FC = () => {
  return (
    <div className='finish-page'>
      Scoring Complete. Please see your results below:
    </div>
  );
};

export default FinishPage;
